import React from 'react'
import {AiOutlineCopyrightCircle} from 'react-icons/ai'
import { Link } from 'react-router-dom'
const Footer = () => {
    return (
        <div className="fixed bottom-0 w-full h-8 flex items-end justify-between px-5 pt-2 pb-1 text-xs text-slate-300">
            <div className='mx-12'>Version <span className='font-bold'>{process.env.REACT_APP_VERSION}</span></div>
            <div className='flex justify-center items-end gap-1'>
                <span>ALL CopyRight </span> 
                <AiOutlineCopyrightCircle className='mb-0.5' />
                <span> <span><Link target='_blank' to={`https://4sharks.org`}>4SHARKS</Link> </span>FOR SOFTWARE SOLUTIONS</span>
            </div>
        </div>
    )
}

export default Footer
